module.exports = __webpack_public_path__ + "static/media/smile--big.6d2e9183.png";